import { parseUrn } from '@atbash-labs/ontology-core'

/**
 * Operator-facing label for a graph `:Database` URN (`connection_id`).
 * Identity stays the URN; the last `db:` segment is the database name
 * (`databaseUrn(compute, name)` → `…/db:<name>`, `urn:db:<name>`).
 */
export function displayDbConnectionName(connectionId: string): string {
  const trimmed = connectionId.trim()
  if (!trimmed) return '—'
  const fromUrn = dbNameFromConnectionUrn(trimmed)
  return fromUrn || trimmed
}

export function dbNameFromConnectionUrn(urn: string): string | undefined {
  if (!urn.startsWith('urn:')) return undefined
  const segments = parseUrn(urn)
  for (let i = segments.length - 1; i >= 0; i--) {
    const segment = segments[i]
    if (segment?.type === 'db' && segment.value) {
      return segment.value
    }
  }
  return undefined
}
